import { type Localisation } from "./en";

export const spanish: Localisation = {
  dateFormats: {
    currentDateFormat: "eee, do LLLL",
    currentTimeFormat: "HH:mm",
    dateDayMonth: "eeee do LLLL",
    hoursMinutes: "HH:mm",
    dateDay: "eeee do",
  },
  StatusProvider: {
    "Screen is active but no token is present":
      "La pantalla está activa pero no hay un token presente",
    "Network error": "Error de red",
    "Checking display status": "Verificando el estado de la pantalla",
    "Failed to get display status":
      "No se pudo obtener el estado de la pantalla",
    "Device ID: {{deviceId}}": "Device ID: {{deviceId}}",
    "If this issue persists, please contact your Teamworks administrator.":
      "Si este problema persiste, comuníquese con su administrador de Teamworks.",
    "This is usually due to a network error while setting up your device. Please reset your device using the button below and try again.":
      "Esto suele deberse a un error de red al configurar su dispositivo. Restablezca su dispositivo usando el botón de abajo e inténtelo de nuevo.",
    "Setup failed to complete": "La configuración no se completó",
    "Please reset your device using the button below and try again.":
      "Por favor, restablezca su dispositivo usando el botón de abajo e inténtelo de nuevo.",
  },
  ConfigProvider: {
    "Loading configuration": "Cargando configuración",
  },
  AppProvider: {
    Loading: "Cargando",
    "No configuration selected": "No se ha seleccionado ninguna configuración",
    "We could not find a configuration for the given code. Please contact your Teamworks administrator.":
      "No pudimos encontrar una configuración para el código proporcionado. Por favor, contacta a tu administrador de Teamworks.",
    "This device has been registered, but no configuration has been set yet. Dont worry, you can easily update this device in the digital displays management app.":
      "Este dispositivo ha sido registrado, pero aún no se ha configurado. No te preocupes, puedes actualizar fácilmente este dispositivo en la aplicación de gestión de pantallas digitales.",
    "Network error: failed to load playlist":
      "Error de red: no se pudo cargar la lista de reproducción",
    "Device ID: {{deviceId}}": "Device ID: {{deviceId}}",
    "Resetting, please wait...": "Restableciendo, por favor espera...",
  },
  UpdatesProvider: {
    "Checking for update": "Buscando actualizaciones",
    "Downloading update": "Descargando actualización",
  },
  InteractionScreen: {
    "Loading...": "Cargando...",
    "Press any key to begin": "Presiona cualquier tecla para comenzar",
    "No configurations assigned": "No hay configuraciones asignadas",
    "You can assign a configuration or a playlist to run on this device in the Digital Displays management app.":
      "Puedes asignar una configuración o una lista de reproducción para ejecutarse en este dispositivo en la aplicación de gestión de pantallas digitales.",
  },
  SetupScreen: {
    "Scan the QR code on your camera app":
      "Escanea el código QR en tu aplicación de cámara",
  },
  TemplateScreen: {
    "Events page {{count}} of {{total}}":
      "Página de eventos {{count}} de {{total}}",
    Today: "Hoy",
    "All day": "Todo el dia",
    Tomorrow: "Mañana",
  },
  ErrorScreen: {
    "Something went wrong": "Algo salió mal",
    "Sorry for the inconvience, our engineers have been notified and will be working on a fix":
      "Disculpe las molestias, nuestros ingenieros han sido notificados y trabajarán en una solución",
    "If this issue persists, please contact your account manager":
      "Si este problema persiste, por favor contacta a tu gerente de cuenta",
    "Reset device": "Restablecer dispositivo",
    "Your IP address may need to be permitted: {{ip}}":
      "Es posible que sea necesario permitir su dirección IP: {{ip}}",
    "The app will attempt to automatically reset in {{seconds}} seconds":
      "La aplicación intentará restablecerse automáticamente en {{seconds}} segundos",
  },
  NextMatch: {
    days: "días",
    hours: "horas",
    minutes: "minutos",
    seconds: "segundos",
  },
  MediaContentCarosel: {
    "Media not found": "Medios no encontrados",
  },
  PlaylistProvider: {
    "Loading...": "Cargando...",
    "Loading playlist": "Cargando lista de reproducción",
  },
  ScreenFooter: {
    Hardcoded: "Codificado",
  },
  NotFoundLayout: {
    "Configuration not found": "Configuración no encontrada",
  },
  StrengthWorkoutBoard: {
    "No Workout Selected": "Ningún entrenamiento seleccionado",
    "Select a workout from the Digital Display tab in S&C to display it here":
      "Selecciona un entrenamiento en la pestaña Digital Display de S&C para mostrarlo aquí",
  },
  WeatherWidget: {
    "Weather unavailable": "Tiempo no disponible",
  },
  NutritionMenu: {
    "Failed to fetch menu": "No se pudo obtener el menú",
  },
  NutritionDiningStation: {
    "Failed to fetch dining station":
      "No se pudo obtener la estación de comida",
    "Add ons will affect nutrition information":
      "Los complementos afectarán la información nutricional",
  },
  Weather: {
    Today: "Today",
    "No weather data to show, please contact your Teamworks administrator.":
      "No hay datos meteorológicos para mostrar, por favor contacte a su administrador de Teamworks.",
    Clear: "Despejado",
    Clouds: "Nublado",
    Rain: "Lluvia",
    Drizzle: "Llovizna",
    Thunderstorm: "Tormenta",
    Snow: "Nieve",
    Mist: "Niebla",
    Smoke: "Humo",
    Haze: "Bruma",
    Dust: "Polvo",
    Fog: "Niebla espesa",
    Sand: "Arena",
    Ash: "Ceniza volcánica",
    Squall: "Ráfaga",
    Tornado: "Tornado",
  },
};
